exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".home .clear-resource,.home .edit-resource{cursor:pointer;margin:0 5px;transition:color .2s}.home .edit-resource:hover{color:blue}.home .clear-resource:hover{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/home/home.scss
// module id = 477
// module chunks = 0